export default __webpack_public_path__ + "static/media/apple-store.00396cd2.svg";